<script setup lang="ts">
import StatItem from '~/components/games/StatItem.vue'

defineProps<{
  name: string
  eventName: null | string
  startingScore: number
  bestOf: number | null
  legsToPlay: number | null
  winner: null | string
  bullWinner: null | string
  player1: string
  player2: string
  player1Legs: number
  player2Legs: number
  player1Average?: null | number
  player2Average?: null | number
  player1First9Average?: null | number
  player2First9Average?: null | number
  player1OneEighties: number
  player2OneEighties: number
  player1OneFourty?: number | undefined
  player2OneFourty?: number | undefined
  player1HighCheckouts: string
  player2HighCheckouts: string
  player1LegDartsUsed: number[]
  player2LegDartsUsed: number[]
}>()
</script>

<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <UiCard
      :title="name"
      :description="eventName ?? ''"
    />
    <UiCard
      v-if="legsToPlay"
      :title="$t('Play {amount} legs', { amount: legsToPlay.toString() })"
      :description="$t('Starting score: {amount}', { amount: startingScore })"
    />
    <UiCard
      v-if="bestOf"
      :title="$t('Best of {amount}', { amount: bestOf.toString() })"
      :description="$t('Starting score: {amount}', { amount: startingScore })"
    />
    <UiCard
      v-if="winner"
      :title="'🏆 ' + winner"
      :description="$t('Winner')"
    />
    <UiCard
      v-if="bullWinner"
      :title="'🎯 ' + bullWinner"
      :description="$t('Bull winner')"
    />
  </div>

  <UiSeparator />

  <div>
    <div class="grid grid-cols-2 gap-8">
      <div class="text-2xl text-right">
        {{ player1 }}
      </div>
      <div class="text-2xl">
        {{ player2 }}
      </div>
    </div>
    <div class="grid grid-cols-2 gap-8">
      <div class="text-right flex flex-col gap-4">
        <StatItem
          class="!text-4xl"
          :highlight="player1Legs > player2Legs"
          :label="$t('Score')"
          :value="player1Legs"
        />
        <StatItem
          v-if="player1Average && player2Average"
          :highlight="player1Average > player2Average"
          :label="$t('Average')"
          :value="player1Average.toFixed(2)"
        />
        <StatItem
          v-if="player1First9Average && player2First9Average"
          :highlight="player1First9Average > player2First9Average"
          :label="$t('First 9')"
          :value="player1First9Average.toFixed(2)"
        />
        <StatItem
          :highlight="player1OneEighties > player2OneEighties"
          :label="$t('180\'s')"
          :value="player1OneEighties.toString()"
        />
        <StatItem
          v-if="player1OneFourty !== undefined && player2OneFourty !== undefined"
          :highlight="player1OneFourty > player2OneFourty"
          :label="$t('140\'s')"
          :value="player1OneFourty.toString()"
        />
        <StatItem
          :label="$t('Darts used (in legs won)')"
          :value="player1LegDartsUsed.join(', ')"
          :highlight="false"
        />
        <StatItem
          :highlight="false"
          :label="$t('High checkouts')"
          :value="player1HighCheckouts === '' ? $t('None') : player1HighCheckouts"
        />
      </div>
      <div class="flex flex-col gap-4">
        <StatItem
          class="!text-4xl"
          :highlight="player2Legs > player1Legs"
          :label="$t('Score')"
          :value="player2Legs"
        />
        <StatItem
          v-if="player2Average && player1Average"
          :highlight="player2Average > player1Average"
          :label="$t('Average')"
          :value="player2Average.toFixed(2)"
        />
        <StatItem
          v-if="player2First9Average && player1First9Average"
          :highlight="player2First9Average > player1First9Average"
          :label="$t('First 9')"
          :value="player2First9Average.toFixed(2)"
        />
        <StatItem
          :highlight="player2OneEighties > player1OneEighties"
          :label="$t('180\'s')"
          :value="player2OneEighties.toString()"
        />
        <StatItem
          v-if="player1OneFourty !== undefined && player2OneFourty !== undefined"
          :highlight="player2OneFourty > player1OneFourty"
          :label="$t('140\'s')"
          :value="player2OneFourty.toString()"
        />
        <StatItem
          :label="$t('Darts used (in legs won)')"
          :value="player2LegDartsUsed.join(', ')"
          :highlight="false"
        />
        <StatItem
          :highlight="false"
          :label="$t('High checkouts')"
          :value="player2HighCheckouts === '' ? $t('None') : player2HighCheckouts"
        />
      </div>
    </div>
  </div>
</template>
